import { render } from "./index.vue?vue&type=template&id=06c5af89&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=06c5af89&lang=less&scoped=true"

import exportComponent from "/Users/gejiayang/Desktop/chunlin-overseas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c5af89"]])

export default __exports__